import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import {Label} from 'bulk-workflows/BulkWorkflowComponents';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';
import {Cell, Column, Table} from 'ui-library/simple-table/SimpleTable';
import TextValue from 'ui-library/TextValue';

// @ts-expect-error module still js
import * as BulkAntibodyActions from '../BulkAntibodyActions';
import {BFISpec, BFITag, BulkAntibody} from '../BulkAntibodyConstants';
import * as BulkAntibodyUtil from '../BulkAntibodyUtil';

function _handleCreate(): void {
  BulkAntibodyActions.create();
}

function BasicFolderItemPreview({name, tags}: BFISpec<BFITag>): JSX.Element {
  return (
    <div>
      <p>{name}</p>
      <div className="u-overflow-x-hidden">
        <Row>
          {Object.entries(tags).map(([tagName, tag]) => (
            <Col key={tagName} sm={6}>
              <Label allCaps={true}>{tagName}</Label>
              <span>
                <TextValue value={tag.value} />
              </span>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

interface BulkAntibodySummaryProps {
  bulkAntibody: BulkAntibody;
}

export default function BulkAntibodySummary({bulkAntibody}: BulkAntibodySummaryProps): JSX.Element {
  if (bulkAntibody.inputFilesLoading) {
    return <HorizontalThrobber />;
  }
  const bfiSpecs = BulkAntibodyUtil.getBasicFolderItemSpecs<false>(bulkAntibody);
  return (
    <div>
      <p>
        {bfiSpecs.length} {benchlingUtil.pluralize(bfiSpecs.length, 'antibody', 'antibodies')} will be
        created.
      </p>
      <Label>Preview</Label>
      <Table numRows={bfiSpecs.length}>
        <Column
          renderCell={(bfiIndex) => (
            <Cell>
              <BasicFolderItemPreview {...bfiSpecs[bfiIndex]} />
            </Cell>
          )}
        />
      </Table>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        size={ButtonSize.MEDIUM}
        disabled={bulkAntibody.isCreating}
        text={bulkAntibody.isCreating ? 'Creating...' : 'Create'}
        onClick={_handleCreate}
      />
    </div>
  );
}
